export const styles = {
  statusWrapper: {
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1,
  },

  button: {
    marginTop: -1,
  },

  expand: (showPath: boolean) => ({
    transform: showPath ? 'rotate(180deg)' : null,
  }),
};
